// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ModificationRepoConfig from "./ModificationRepoConfig.bs.js";

var dummy_modification_list = {
  "modification_campaigns": [
    {
      "external_id": "210453e2-e3e0-4f5b-9e8f-62ea8a6d9f7f",
      "name": "dfsfsf",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 1000
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 1200
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              1
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-06-20",
      "end_date": null,
      "start_instant": 1687199400000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1687177253083
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "10:49:00.000",
        "end_time": "11:54:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-test",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 1000
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": -1200000,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": -2000
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 1200000,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              0,
              1,
              3
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-06-16",
      "end_date": "2023-07-28",
      "start_instant": 1686853800000,
      "end_instant": 1690482600000,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1686732086730
      },
      "status": {
        "campaign_status": "scheduled",
        "priority": 1,
        "approval_time": 1686732104688,
        "approver": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        }
      },
      "eligibility_config": {
        "start_time": "09:46:00.000",
        "end_time": "10:52:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-test09",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "simple_modification",
          "delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 1200
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-27",
      "end_date": null,
      "start_instant": 1690396200000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1689920811605
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "01:05:00.000",
        "end_time": "14:10:00.000",
        "repeat_on_days": [
          "TUESDAY",
          "FRIDAY"
        ],
        "pickup_zone_ids": [
          36,
          37
        ],
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-test-01",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "simple_modification",
          "delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 1200
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-28",
      "end_date": null,
      "start_instant": 1690482600000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1689920868892
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "12:01:00.000",
        "end_time": "14:10:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-test-02",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 100
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 11,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              2,
              6
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-25",
      "end_date": null,
      "start_instant": 1690223400000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1690201819817
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "02:10:00.000",
        "end_time": "17:25:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-simple",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "simple_modification",
          "delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 400
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 100
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-27",
      "end_date": null,
      "start_instant": 1690396200000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1690375946315
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "13:06:00.000",
        "end_time": "15:16:00.000",
        "repeat_on_days": [
          "MONDAY",
          "THURSDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-ab-001",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 100
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 11,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 26,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 300
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              1,
              4
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-27",
      "end_date": "2023-07-29",
      "start_instant": 1690396200000,
      "end_instant": 1690569000000,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1690376077490
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "13:04:00.000",
        "end_time": "16:19:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-nskdjahd",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 100
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 300
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              5,
              4,
              3,
              2,
              1
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-28",
      "end_date": null,
      "start_instant": 1690482600000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1690435600344
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "13:05:00.000",
        "end_time": "16:19:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-ab-test012",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 100
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 400
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        },
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 200
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 400
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              15,
              16,
              17,
              18,
              19,
              20,
              21,
              22,
              23,
              24,
              25,
              26,
              27,
              28,
              29,
              30
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        },
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 300
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 1000
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 400
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 2000
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              40,
              41,
              42,
              43,
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54,
              55
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-28",
      "end_date": "2023-07-29",
      "start_instant": 1690482600000,
      "end_instant": 1690569000000,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1690445355817
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "13:06:00.000",
        "end_time": "16:20:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-ab-2saddsa",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2022-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 100
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 300
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        },
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 200
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 300
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 0,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54,
              55,
              56,
              57,
              58,
              59,
              60,
              61,
              62,
              63,
              64,
              65,
              66,
              67,
              68,
              69,
              70
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-28",
      "end_date": null,
      "start_instant": 1690482600000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1690448839268
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "02:09:00.000",
        "end_time": "15:15:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    },
    {
      "external_id": "00000000-0000-0000-0000-00000000000",
      "name": "test-dome-231",
      "core_pricing_structure_campaign": {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "sdasd_hypertest_48861lc2z9dz3",
        "geo_region_id": 1,
        "vehicle_id": 1,
        "start_date": "2023-12-26",
        "end_date": null,
        "start_instant": 1671993000000,
        "end_instant": null,
        "creation_info": {
          "creator": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1671948991014
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1671948992348,
          "approver": {
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 21000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 400
          },
          "free_duration": 4800000,
          "free_distance_pricing": {
            "free_kms": 2,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 400
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2100
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            }
          ]
        }
      },
      "modification": [
        {
          "modification": "ab_modification",
          "test_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 100
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 60000,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 3,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 200
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 200
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "control_delta": {
            "base_fare_delta": {
              "currency": "INR",
              "minor_amount": 200
            },
            "waiting_rate_per_minute_delta": {
              "currency": "INR",
              "minor_amount": 0
            },
            "free_duration_delta": 120000,
            "free_distance_pricing_delta": {
              "free_kms_delta": 0,
              "price_per_min_delta": {
                "currency": "INR",
                "minor_amount": 0
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 4,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 300
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          },
          "test_sample_criteria": {
            "customer_id_buckets": [
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18,
              19,
              20
            ]
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        }
      ],
      "start_date": "2023-07-28",
      "end_date": null,
      "start_instant": 1690482600000,
      "end_instant": null,
      "creation_info": {
        "creator": {
          "first_name": "test",
          "last_name": "test",
          "email": "test@xyz.com"
        },
        "creation_time": 1690449920938
      },
      "status": {
        "campaign_status": "pending"
      },
      "eligibility_config": {
        "start_time": "13:06:00.000",
        "end_time": "15:16:00.000",
        "repeat_on_days": [
          "SUNDAY",
          "MONDAY",
          "TUESDAY",
          "WEDNESDAY",
          "THURSDAY",
          "FRIDAY",
          "SATURDAY"
        ],
        "pickup_zone_ids": null,
        "drop_zone_ids": null,
        "pickup_cluster_ids": null,
        "drop_cluster_ids": null
      }
    }
  ]
};

var dummy_post_call_re = {};

var dummy_create_modification_error_res = {
        "type": "core_campaign_not_found",
        "validation_results": [
          {
            "type": "Base Fare Validation",
            "failure_reason": "Base Fare should be within 0.0 and 3000.0, given 20000.0"
          },
          {
            "type": "Effective from date validation",
            "failure_reason": "Not a valid date: 2021-03-26, valid input date is within 2021-03-27 and 2021-09-22"
          }
        ],
        "message": null
      };

function fetchModifications(_campaign_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummy_modification_list
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.ModificationListResponseConverter.execute, result);
                        });
            });
}

function createModification(payload, iso_code, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* UnprocessedEntity */2,
                              _0: dummy_create_modification_error_res
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.CreateModificationResponseConverter.execute, result);
                        });
            });
}

function editModification(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummy_post_call_re
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.EditModificationResponseConverter.execute, result);
                        });
            });
}

function reprioritizeModification(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummy_post_call_re
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.ReprioritizeModificationResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchModifications: fetchModifications,
  createModification: createModification,
  editModification: editModification,
  reprioritizeModification: reprioritizeModification
};

export {
  T ,
  
}
/* ModificationRepoConfig Not a pure module */
